import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Cards from '../components/cards'
import Card from '../components/card'
import Componentparameters from '../components/componentparameters'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './materials.css'

const Materials = (props) => {
  return (
    <div className="materials-container1">
      <Helmet>
        <title>Материалы для WAAM-печати металлом | Сварочная проволока</title>
        <meta
          name="description"
          content="Проволока и сплавы для WAAM по стандартам AWS, ASTM, ISO и ГОСТ. Подбор материалов под деталь, требования эксплуатации и технологию печати."
        />
        <meta
          property="og:title"
          content="Материалы для WAAM-печати металлом | Сварочная проволока"
        />
        <meta
          property="og:description"
          content="Проволока и сплавы для WAAM по стандартам AWS, ASTM, ISO и ГОСТ. Подбор материалов под деталь, требования эксплуатации и технологию печати."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Материалы для WAAM-печати металлом | Сварочная проволока"
        />
        <meta
          name="twitter:description"
          content="Проволока и сплавы для WAAM по стандартам AWS, ASTM, ISO и ГОСТ. Подбор материалов под деталь, требования эксплуатации и технологию печати."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/materials"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/materials"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Materials","item":"https://arcobo.tech/materials"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name26"></HeaderMain>
      <hr className="materials-separator1"></hr>
      <Componenttextimage
        rootClassName="componenttextimageroot-class-name14"
        textComponent={
          <Fragment>
            <span className="materials-text10">
              <span>
                Для технологии WAAM металлическая сварочная проволока
                используется в качестве исходного материала. По сравнению с
                порошковыми технологиями металлическая проволока значительно
                дешевле, проще в хранении и обеспечивает практически 100%
                использование материала без потерь.
              </span>
              <br></br>
              <br></br>
              <span>
                Arcobo применяет только проверенные сварочные материалы с
                подтвержденными механическими свойствами. Перед внедрением новых
                марок проволоки или новых поставщиков инженеры Arcobo проводят
                комплексные испытания, включая оценку стабильности процесса,
                механических свойств и качества наплавленного металла.
              </span>
              <br></br>
              <br></br>
              <br></br>
            </span>
          </Fragment>
        }
        componentTitle="Материалы для WAAM-печати и роботизированной наплавки"
      ></Componenttextimage>
      <Cards
        text="Для технологии WAAM подходят только свариваемые  сплавы. Мы подбираем материал под условия эксплуатации детали, требования по прочности, коррозионной стойкости, температурному режиму и стоимости производства."
        text1={
          <Fragment>
            <span className="materials-text18">
              Для технологии WAAM подходят только свариваемые сплавы. Мы
              подбираем материал под условия эксплуатации детали, требования по
              прочности, коррозионной стойкости, температурному режиму и
              стоимости производства.
            </span>
          </Fragment>
        }
        heading="Доступные сплавы\xA0"
        heading1={
          <Fragment>
            <span className="materials-text19">Доступные сплавы </span>
          </Fragment>
        }
        rootClassName="cardsroot-class-name"
      ></Cards>
      <div className="materials-container2">
        <Card
          text={
            <Fragment>
              <span className="materials-text20">
                <span>
                  Конструкционные, нержавеющие, инструментальные и износостойкие
                  стали.
                </span>
                <br></br>
                <span>
                  Машиностроение, горнодобывающая промышленность, металлургия,
                  энергетика
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="materials-text25">Стали</span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_4_Materials/steel-300h.webp"
          imageAlt="Стали для WAAM-печати"
          rootClassName="cardroot-class-name45"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="materials-text26">
                <span>Легкие материалы с высокой коррозионной стойкостью.</span>
                <br></br>
                <span>
                  Транспорт, авиация, оснастка и легкие конструкции
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="materials-text33">
                <span>Al сплавы</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_4_Materials/aluminium-300h.webp"
          imageAlt="Алюминиевые сплавы для WAAM-печати"
          rootClassName="cardroot-class-name64"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="materials-text36">
                <span>
                  Жаропрочные материалы для работы в экстремальных условиях.
                </span>
                <br></br>
                <span>
                  Энергетика, нефтегазовая отрасль, химическая промышленность,
                  авиация
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
                <br></br>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="materials-text43">
                <span>Ni сплавы</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_4_Materials/nickel-300h.webp"
          imageAlt="Никелевые сплавы для WAAM-печати"
          rootClassName="cardroot-class-name63"
        ></Card>
        <Card
          text={
            <Fragment>
              <span className="materials-text46">
                <span>
                  Высокая прочность при минимальной массе и исключительная
                  коррозионная стойкость.
                </span>
                <br></br>
                <span>
                  Авиация, космос, медицина, химическое оборудование и
                  высоконагруженные конструкции
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
              </span>
            </Fragment>
          }
          heading1={
            <Fragment>
              <span className="materials-text51">
                <span>Ti сплавы</span>
                <br></br>
              </span>
            </Fragment>
          }
          imageSrc="/2_3D Printing/2_4_Materials/titanium-300h.webp"
          imageAlt="Титановые сплавы для WAAM-печати"
          rootClassName="cardroot-class-name57"
        ></Card>
      </div>
      <hr className="materials-separator2"></hr>
      <Componentparameters
        text1={
          <Fragment>
            <span className="materials-text54">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="materials-text55">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="materials-text56">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="materials-text57">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="materials-text58">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
              enim ad minim veniam, quis nostrud exercitation ullamco laboris
              nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in
              reprehenderit in voluptate velit esse cillum dolore eu fugiat
              nulla pariatur
            </span>
          </Fragment>
        }
        showH2
        showDiv2={false}
        showDiv3={false}
        showDiv4={false}
        showDiv5={false}
        rootClassName="componentparametersroot-class-name7"
      ></Componentparameters>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="materials-text59">
              <span>
                Технология WAAM позволяет изготавливать детали из большинства
                промышленных свариваемых материалов в виде проволоки. Наиболее
                распространены конструкционные и нержавеющие стали, алюминиевые,
                титановые, никелевые, медные и бронзовые сплавы. Выбор материала
                определяется условиями эксплуатации детали и требованиями к ее
                механическим свойствам.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="materials-text62">
              <span>
                WAAM использует стандартную сварочную проволоку, которая
                значительно дешевле металлических порошков, проще в хранении и
                транспортировке и обеспечивает коэффициент использования
                материала до 99%. Кроме того, проволока выпускается десятками
                производителей по всему миру и доступна для большинства
                промышленных сплавов.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="materials-text65">
              <span>
                Инженеры Arcobo подбирают материал исходя из условий
                эксплуатации изделия. При выборе учитываются механические
                нагрузки, температура работы, износ, воздействие агрессивных
                сред, требования к последующей механической обработке, срок
                службы и стоимость изготовления.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="materials-text68">
              <span>Нет.</span>
              <br></br>
              <span>
                Arcobo применяет только проверенные материалы с подтвержденными
                характеристиками. Перед использованием новых марок проволоки или
                новых поставщиков проводятся технологические испытания,
                оцениваются стабильность процесса, качество наплавленного
                металла и механические свойства полученных образцов.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="materials-text73">
              <span>Да.</span>
              <br></br>
              <span>
                При необходимости Arcobo выполняет изготовление и восстановление
                деталей из сварочной проволоки, предоставленной заказчиком.
                Перед запуском проекта проводится проверка материала и
                технологические испытания для подтверждения возможности его
                использования в процессе WAAM.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="materials-text78">
              <span>
                На складе Arcobo постоянно поддерживается запас наиболее
                востребованных сварочных материалов для оперативного запуска
                проектов. Остальные марки проволоки поставляются под заказ после
                согласования технологии и сроков изготовления.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="materials-text81">
              <span>Да.</span>
              <br></br>
              <span>
                Если необходимая проволока отсутствует на складе, Arcobo
                организует поставку материала, проведет тестовую печать при
                необходимости и разработает технологию изготовления или
                восстановления детали под конкретную задачу.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="materials-text86">
              <span>
                Технология WAAM основана на сварочных процессах, поэтому для нее
                подходят только материалы, обладающие хорошей свариваемостью и
                выпускаемые в виде сварочной проволоки. Для некоторых
                трудносвариваемых или экспериментальных сплавов требуется
                предварительная разработка технологии и проведение испытаний.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        showDiv={false}
        showDiv1={false}
        showDiv2={false}
        showDiv3={false}
        showDiv4={false}
        showDiv5={false}
        showDiv6={false}
        showDiv7={false}
        question1="Какие материалы подходят для технологии WAAM?"
        question2="Почему в WAAM используется сварочная проволока, а не металлический порошок?"
        question3="Как Arcobo выбирает материал для изготовления детали?"
        question4="Использует ли Arcobo новые материалы без предварительных испытаний?"
        question5="Можно ли использовать материал заказчика?"
        question6="Какие материалы имеются на складе Arcobo?"
        question7="Можно ли изготовить деталь из материала, которого нет в наличии?"
        question8="Какие материалы нельзя использовать в WAAM?"
        rootClassName="componentfaqroot-class-name13"
      ></Componentfaq>
      <hr className="materials-separator3"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name25"></FooterMain>
    </div>
  )
}

export default Materials
